import * as React from 'react';
import { IReportType } from 'helpers/interfaces';
import * as i18next from 'i18next';
import { withRouter } from '../../../helpers/HOCs/withRouter';

interface IProps {
    t: i18next.TFunction;
    properties: IReportType;
    isEnabled: boolean;
    navigate: Function;
}

const ReportsMenuItem = (props: IProps) => {
    const { t, properties, isEnabled, navigate } = props;
    const { icon, description, link } = properties;

    return (
        <div
            className={`
                flex items-end w-full md:w-[260px] h-[80px] md:h-[112px] mb-2.5 md:mr-2.5
                rounded-lg bg-white p-[18px] cursor-pointer border border-gray-200
                ${isEnabled ? '' : 'bg-white/50 cursor-not-allowed'}
            `}
            onClick={() => isEnabled && navigate(link)}
        >
            <div className="text-[40px] text-[#E6E6E8]">
                {icon}
            </div>
            <p className={`
                w-[60%] ml-2.5 m-0 leading-5 text-[17px] font-bold tracking-[0.33px]
                ${isEnabled ? 'text-[#0B1022]' : 'text-[#e2e2e2]'}
            `}>
                {t(description)}
            </p>
        </div>
    );
};

export default withRouter(ReportsMenuItem);
